import BaseService from './BaseService'

class InvoiceService extends BaseService {
  constructor() {
    super('/invoices')
  }

  update(id, payload) {
    return this.customRequest('put', `/${id}`, payload)
  }

  updateRouting(id, payload) {
    return this.customRequest('put', `/${id}`, payload)
  }

  issue(id) {
    return this.customRequest('post', `/${id}/issue`)
  }

  promoteEstimate(id) {
    return this.customRequest('post', `/${id}/promote-estimate`)
  }

  deleteDraft(id) {
    return this.customRequest('delete', `/${id}`)
  }

  void(id) {
    return this.customRequest('post', `/${id}/void`)
  }

  cancel(id) {
    return this.customRequest('post', `/${id}/cancel`)
  }

  refund(id) {
    return this.customRequest('post', `/${id}/refund`)
  }

  downloadPdf(id) {
    // Return full axios response to handle blob
    return this.customRequest('get', `/${id}/pdf`, null, { responseType: 'blob' })
  }

  getHtml(id) {
    return this.customRequest('get', `/${id}/html`)
  }

  getRecurringTemplates(params = {}) {
    return this.customRequest('get', '/recurring-templates', null, { params })
  }

  listAttachments(id) {
    return this.customRequest('get', `/${id}/attachments`)
  }

  uploadAttachment(id, file) {
    const form = new FormData()
    form.append('file', file)
    return this.customRequest('post', `/${id}/attachments`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
  }

  deleteAttachment(id, attachmentId) {
    return this.customRequest('delete', `/${id}/attachments/${attachmentId}`)
  }

  updateNotes(id, internalNotes) {
    return this.customRequest('put', `/${id}/notes`, { internal_notes: internalNotes })
  }

  getAttachmentUrl(id, attachmentId) {
    return this.customRequest('get', `/${id}/attachments/${attachmentId}/url`)
  }

  getAttachmentThumbUrl(id, attachmentId) {
    return this.customRequest('get', `/${id}/attachments/${attachmentId}/thumb-url`)
  }

  sendEmail(id, payload) {
    return this.customRequest('post', `/${id}/email`, payload)
  }

  sendSms(id, payload) {
    return this.customRequest('post', `/${id}/sms`, payload)
  }

  getPayments(id) {
    return this.customRequest('get', `/${id}/payments`)
  }

  recordPayment(id, payload) {
    return this.customRequest('post', `/${id}/record-payment`, payload)
  }

  removePayment(invoiceId, applicationId) {
    return this.customRequest('delete', `/${invoiceId}/payments/${applicationId}`)
  }

  openForCustomer(params = {}) {
    return this.customRequest('get', '/open-for-customer', null, { params })
  }

  recordRegisterPayment(payload) {
    return this.customRequest('post', '/payments/register', payload)
  }

  getRecurring(id) {
    return this.customRequest('get', `/${id}/recurring`)
  }

  previewRecurring(payload) {
    return this.customRequest('post', '/recurring/preview', payload)
  }

  upsertRecurring(id, payload) {
    return this.customRequest('post', `/${id}/recurring`, payload)
  }

  pauseRecurring(id) {
    return this.customRequest('post', `/${id}/recurring/pause`)
  }

  resumeRecurring(id) {
    return this.customRequest('post', `/${id}/recurring/resume`)
  }

  endRecurring(id) {
    return this.customRequest('post', `/${id}/recurring/end`)
  }

  sendAutopayEnrollmentLink(id, payload) {
    return this.customRequest('post', `/${id}/recurring/send-enrollment-link`, payload)
  }

  getRecurringBillingAgreements(params = {}) {
    return this.customRequest('get', '/recurring/billing-agreements', null, { params })
  }

  bulkImportRecurring(payload) {
    return this.customRequest('post', '/recurring/bulk-import', payload)
  }

  getActivity(id, params = {}) {
    return this.customRequest('get', `/${id}/activity`, null, { params })
  }

  syncLabels(id, labelIds) {
    return this.customRequest('put', `/${id}/labels`, { label_ids: labelIds })
  }

  // Links removed in favor of fulfillment events
}

export default new InvoiceService()


